export default __webpack_public_path__ + "static/media/b_junta_de_directores.aa253f55.jpg";